import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMessages } from '../../services/engage-targeting';
import { setMessageMapping } from '../engagement-actions';
import { store } from '../engagement-store';

/**
 * Returns a mapping of event to message. A message can have multiple events mapping to it.
 */
export var getEventToMessageMapping = function getEventToMessageMapping(messages) {
  var mapping = new Map();
  messages.forEach(function (message) {
    var components = message.components;
    components.forEach(function (component, index) {
      component.triggers.forEach(function (trigger) {
        mapping.set(trigger, {
          message: message,
          component: _objectSpread({
            componentId: index,
            isLast: index === components.length - 1
          }, component)
        });
      });
    });
  });
  return mapping;
};

/**
 * We fetch messages from targeting and re-fetch based on interval from targeting.
 *
 * If the interval is set to 0, we don't process.
 *
 * If there's an active message, we don't update the store either as that will cause the current
 * message to be added back to the message mapping.
 */
export function processMessages(_x, _x2, _x3) {
  return _processMessages.apply(this, arguments);
}
function _processMessages() {
  _processMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engagementStore, config, cancellationToken) {
    var state, cloudId, stargateUrl, product, locale, messages, interval, results, messageMapping;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!cancellationToken.isCancelled) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          state = store.getState();
          cloudId = config.cloudId, stargateUrl = config.stargateUrl, product = config.product, locale = config.locale;
          _context.prev = 4;
          _context.next = 7;
          return getMessages(cloudId, stargateUrl, product, locale);
        case 7:
          results = _context.sent;
          if (!cancellationToken.isCancelled) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return");
        case 10:
          messages = results.messages;
          interval = results.interval;
          _context.next = 17;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](4);
          return _context.abrupt("return");
        case 17:
          // Don't overwrite the messageMapping if there's an active message
          if (state.current === null) {
            messageMapping = getEventToMessageMapping(messages);
            engagementStore.dispatch(setMessageMapping(messageMapping));
          }
          if (interval !== 0) {
            setTimeout(function () {
              processMessages(engagementStore, config, cancellationToken);
            }, interval * 1000);
          }
          // TODO: Configure metal to monitor success response here
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 14]]);
  }));
  return _processMessages.apply(this, arguments);
}